import { createFileRoute } from "@tanstack/react-router";
import WhatTmsFeelsLike from "@/pages/WhatTmsFeelsLike";
export const Route = createFileRoute("/what-tms-feels-like")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What TMS Feels Like | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What does TMS feel like? Learn about the tapping sensation, session length, and side effects at Neuro Wellness TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "What TMS Feels Like | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What does TMS feel like? Learn about the tapping sensation, session length, and side effects at Neuro Wellness TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/what-tms-feels-like",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/what-tms-feels-like",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <WhatTmsFeelsLike />;
}
